import { render, staticRenderFns } from "./change-plan-details.vue?vue&type=template&id=05e6a2c8&scoped=true&"
import script from "./change-plan-details.vue?vue&type=script&lang=ts&"
export * from "./change-plan-details.vue?vue&type=script&lang=ts&"
import style0 from "./change-plan-details.vue?vue&type=style&index=0&id=05e6a2c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e6a2c8",
  null
  
)

export default component.exports